export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/environments/environment.ts